var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column fit"},[_c('div',{staticClass:"col-auto"},[_c('AccountManagementNavbarHeaderContainer')],1),_c('div',{staticClass:"col",staticStyle:{"overflow-y":"auto"}},[_c('AccountManagementModalTabs')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }